import React from 'react';
import { Box, Typography, Stack, Paper } from '@mui/material';

const Timeline = ({ timeline }) => (
  <Box
    id="education"
    sx={{
      py: { xs: 4, md: 6 },
      maxWidth: { xs: '100%', md: 1200 },
      mx: 'auto',
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 4 }}>
      <Box
        sx={{
          width: '4px',
          height: { xs: '24px', md: '32px' },
          bgcolor: 'primary.main',
          mr: 2,
        }}
      />
      <Typography
        variant="h2"
        sx={{
          fontSize: { xs: 24, md: 32 },
          fontWeight: 700,
          color: 'text.primary',
        }}
      >
        Education
      </Typography>
    </Box>
    <Stack spacing={3}>
      {timeline.map((item, index) => (
        <Paper
          key={index}
          elevation={1}
          sx={{
            p: 3,
            borderRadius: 2,
            bgcolor: 'background.paper',
            border: '1px solid',
            borderColor: 'divider',
            transition: 'transform 0.2s, box-shadow 0.2s',
            '&:hover': {
              transform: 'translateY(-4px)',
              boxShadow: 3,
              borderColor: 'primary.main',
            },
          }}
        >
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ xs: 'flex-start', sm: 'center' }}>
            <Box
              component="img"
              src={item.logo}
              alt={item.org}
              sx={{
                width: { xs: 60, sm: 80 },
                height: { xs: 60, sm: 80 },
                objectFit: 'contain',
                borderRadius: 1,
                bgcolor: 'background.paper',
                p: 1,
              }}
            />
            <Box sx={{ flex: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: { xs: 18, md: 20 },
                    fontWeight: 600,
                    color: 'text.primary',
                  }}
                >
                  {item.title}
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: { xs: 18, md: 20 },
                    color: 'text.secondary',
                    fontStyle: 'italic'
                  }}
                >
                  ({item.date})
                </Typography>
              </Box>
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: { xs: 16, md: 18 },
                  color: 'text.secondary',
                  mb: 0.5,
                }}
              >
                {item.org}, {item.location}
              </Typography>
            </Box>
          </Stack>
        </Paper>
      ))}
    </Stack>
  </Box>
);

export default Timeline; 